import { atom } from 'recoil';

export const hasCoAccountHolderAtom = atom<boolean>({
    key: 'hasCoAccountHolder',
    default: false
});
